import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.scss']
})
export class StackedBarChartComponent implements OnInit {

  /**
   * all the styling and data input are mentioned here.
   */
  productSalesMultiple: any[] | undefined;
  view: any = [600, 400];
  colorScheme = {
    domain: ['#8B008B', '#4B852C', '#B67A3D', '#5B6FCB'],
  };


  schemeType: string = 'ordinal';
  gradient: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  legend: boolean = true;
  legendTitle: string = 'products';
  showXAxisLabel: boolean = true;
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'sales';
  xAxisLabel: string = 'products';

  /** constructor */
  constructor() {
    // Object.assign(this, { productSalesMultiple });
  }

  ngOnInit(): void {
  }


}
